import React, { useState } from 'react';
import InputField from '../Reusable/InputField';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ChangePasswordForm } from '../../enums/ChangePasswordEnums';
import { SubmitButton } from '../../enums/GlobalEnums';
import { useSelector } from 'react-redux';

const ModalForChangePassword = ({ showChangePasswordModal, handleClose, handleChangePassword }) => {
  const securityReducer = useSelector((state) => state.security);
  const { error } = securityReducer;
  const [changePasswordRequestData, setchangePasswordRequestData] = useState({
    username: '',
    password: '',
    confirmPassword: '',
  });

  const onChange = (e) => {
    const { name, value } = e.target;
    setchangePasswordRequestData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const changePasswordDTO = {
      ...changePasswordRequestData,
    };
    handleChangePassword(changePasswordDTO);
  };

  return (
      <Dialog
        open={showChangePasswordModal}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          {ChangePasswordForm.changePasswordFormTitle}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <div className="form-group">
            <InputField
              name="username"
              placeholder={ChangePasswordForm.changePasswordPlaceholderUsername}
              onChange={onChange}
              required
              defaultValue={changePasswordRequestData.username}
              error={error?.username}
            />
          </div>
          <div className="form-group">
            <InputField
              name="password"
              placeholder={ChangePasswordForm.changePasswordPlaceholderPassword}
              onChange={onChange}
              required
              value={changePasswordRequestData.password}
              autoComplete="off"
              type="password"
              error={error?.password}
            />
          </div>
          <div className="form-group">
            <InputField
              name="confirmPassword"
              placeholder={
                ChangePasswordForm.changePasswordPlaceholderConfirmPassword
              }
              onChange={onChange}
              required
              value={changePasswordRequestData.confirmPassword}
              autoComplete="off"
              type="password"
              error={error?.confirmPassword}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSubmit} variant="contained" color="primary">
            {SubmitButton.save}
          </Button>
        </DialogActions>
      </Dialog>
  );
};
export default ModalForChangePassword;
